import { create } from "zustand";
import api from "../api/axios";

const useEmployeeExitStore = create((set) => ({
  employeeExitData: [],
  loading: false,

  fetchEmployeeExitData: async (
    selectedCompany
  ) => {
    try {
      set({ loading: true });

      const response = await api.get(
        `/employees/ExitEmployeeData?company=${selectedCompany}`
      );

      const employeeExitData =
        response.data?.data || [];

      set({
        employeeExitData,
        loading: false,
      });

      return employeeExitData;
    } catch (error) {
      console.error(error);

      set({
        loading: false,
      });

      return [];
    }
  },
}));

export default useEmployeeExitStore;